var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmSenviado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5886_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.9991H13L9 12.9991V2.99908C9 2.46865 9.21071 1.95994 9.58579 1.58487C9.96086 1.2098 10.4696 0.999084 11 0.999084H21C21.5304 0.999084 22.0391 1.2098 22.4142 1.58487C22.7893 1.95994 23 2.46865 23 2.99908V8.99908C23 9.52952 22.7893 10.0382 22.4142 10.4133C22.0391 10.7884 21.5304 10.9991 21 10.9991Z",
    stroke: "#442E83",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2.99908H4C3.46957 2.99908 2.96086 3.2098 2.58579 3.58487C2.21071 3.95994 2 4.46865 2 4.99908V20.9991C2 21.5295 2.21071 22.0382 2.58579 22.4133C2.96086 22.7884 3.46957 22.9991 4 22.9991H15C15.5304 22.9991 16.0391 22.7884 16.4142 22.4133C16.7893 22.0382 17 21.5295 17 20.9991V13.9991",
    stroke: "#442E83",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5886_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 -0.000915527)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmSenviado);
export default __webpack_public_path__ + "static/media/SMSenviado.69ea8a5a958dd1962dade802d0aa2790.svg";
export { ForwardRef as ReactComponent };